import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/unit-conversion',
  component: () => import('../../routes/UnitConversion.svelte'),
  card: {
    id: 'unit-conversion',
    title: 'Unit Conversion',
    description: 'Convert between units of length, weight, temperature, volume, area, speed, and time instantly.',
    icon: 'swap_horiz',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/unit-conversion',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Unit Conversion Calculator – Length, Weight, Temperature & More',
    description: 'Free unit conversion calculator to convert length, weight, temperature, volume, area, speed, and time units instantly. Metric, imperial, and US customary conversions in one tool.',
  },
};

export default meta;
